// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type TargetStrategy } from '@shared/data-access/interfaces/api/ai/target-strategy';
import { type Holding } from '@shared/data-access/interfaces/api/ai/holding';

export interface PortfolioStrategy {
  holdings: Holding[];
  benchmark: TargetStrategy;
}

export const baseHoldingPayload = {
  date: '',
  holding_id: '',
  isin: '',
  ticker: '',
  unrealized_capital_gains: 0,
};

export const targetAssetPayload = {
  ticker: '',
  weight: 0,
};

export const holdingsPayload = {
  ...baseHoldingPayload,
  qty: 0,
  price: 0,
};

export const portfolioStrategyPayload: PortfolioStrategy = {
  benchmark: {
    target_asset: [
      {
        ...targetAssetPayload,
        isin: '',
      },
    ],
  },
  holdings: [holdingsPayload],
};
